export default "__VITE_ASSET__ClIWWSy1__"